export default __webpack_public_path__ + "static/media/intro.46204af8.png";